
import { Skeleton } from '@/components/ui/skeleton';
import { useTranslation } from 'react-i18next';

export function PublicMenuLoading() {
  const { t } = useTranslation();
  
  return (
    <div className='container mx-auto py-8'>
      <div className='text-center mb-8'>
        <Skeleton className='h-12 w-3/4 mx-auto mb-4' />
        <Skeleton className='h-6 w-1/2 mx-auto' />
      </div>
      <div className='grid gap-6 md:grid-cols-2 lg:grid-cols-3'>
        {[...Array(6)].map((_, i) => (
          <Skeleton key={i} className='h-72 w-full rounded-lg' />
        ))}
      </div>
    </div>
  );
}
